module.exports = __webpack_public_path__ + "static/media/gameCare.33e12720.svg";